var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    strokeLinejoin: "round",
    strokeMiterlimit: 2,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Calendar") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.82 1.89h-1.97V1c0-.55-.45-1-1-1s-1 .45-1 1v.89h-5.7V1c0-.55-.45-1-1-1s-1 .45-1 1v.89H4.18C1.88 1.89 0 3.77 0 6.08v3.24c0 .55.45 1 1 1h19v7.5c0 1.2-.98 2.18-2.18 2.18H4.18C2.98 20 2 19.02 2 17.82v-4.58c0-.55-.45-1-1-1s-1 .45-1 1v4.58C0 20.13 1.88 22 4.18 22h13.64c2.31 0 4.18-1.88 4.18-4.18V6.08c0-2.31-1.88-4.18-4.18-4.18v-.01zM2 8.31V6.07c0-1.2.98-2.18 2.18-2.18h1.97v.89c0 .55.45 1 1 1s1-.45 1-1v-.89h5.7v.89c0 .55.45 1 1 1s1-.45 1-1v-.89h1.97c1.2 0 2.18.98 2.18 2.18v2.24H2z",
    fillRule: "nonzero"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/Calendar.51c7e623c02ff0b54669630a4f46b9de.svg";
export { ForwardRef as ReactComponent };